import types from "../types/types";

export const problematikat = (problem, type = types.SET_PROBLEMS) => {
    return (dispatch) => {
        dispatch({
            type: type,
            payload: problem
        })
    }
}